/*
Prakash 10/31/2022 3225736869 Added Pagination for Table and Styling Buttons.
saikrishna 11/03/2022 3225736869 changed the paginationOptions
*/
import React, {createRef, useState, useContext, useEffect} from 'react';
// import MaterialTable from "material-table";
import {TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {
  postSystemNotes,
  ResetMessage as resetMessage,
  ResetStatus as resetStatus,
} from '../../../../../redux/reducers/NightJobs/AddNightJob';
import DialogBox from '../../../../../components/DialogBox';
import AddIcon from '@material-ui/icons/Add';
import AddUserDefinedNotes from '../../../../../components/AddUserDefinedNotes';
import {Button} from '@material-ui/core';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
export default function FiltersSystemNotes({nightJobCode}) {
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Note Type',
      field: 'noteType',
    },

    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Job Code',
      field: 'jobCode',
      render: (rowData) => <>{rowData?.code}</>,
    },
    {
      title: 'Note Text',
      field: 'noteText',
      type: 'string',
      cellStyle: {
        minWidth: '550px',
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
  ];

  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  let transcription = '';
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  const {systemNotesStatus, isSystemNoteLoading} = useSelector(({addNightJob}) => addNightJob);
  useEffect(() => {
    if (systemNotesStatus === 200) {
      handleDialogClose();
      tableRef.current.onQueryChange();
      dispatch(resetStatus());
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [systemNotesStatus]);

  const dispatchRecordFormatSystemNotes = (data) => {
    if (data) {
      dispatch(
        postSystemNotes({
          code: nightJobCode ? nightJobCode : '',
          noteText: data,
        }),
      );
    }
  };
  return (
    <div>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            isLoading={isSystemNoteLoading}
            charLimitMsg={charLimitMsg}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
          />
        )}
      </DialogBox>
      <div className="custom-table custom-toolbar-icons global-field-table">
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          data={(query) =>
            new Promise((resolve) => {
              const url = `jobs/search/jobtask`;
              const bodyObj = {
                code: nightJobCode,
                limit: rows,
                orderBy: '',
                orderDirection: '',
                search: '',
                page:
                arrayLast && query.page >= 1 ?
                  query.page :
                  arrayLast ?
                    (query.page <= 1 && query.page + 1) || query.page - 1 :
                    query.page + 1,
              };
              if (!nightJobCode) {
                resolve({
                  data: [],
                  page: 0,
                  totalCount: 5,
                });
              } else {
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObjects;
                      resolve({
                        data: data.length > 0 ? data : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(response.data.response.resultObjects.length === 1);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              }
            })
          }
          options={{
            toolbar: true,
            search: false,
            pageSize: rows,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            pageSizeOptions: tablePageRows,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          components={{
            Pagination: (props) => (
              <TablePagination
                {...props}
                SelectProps={{
                  inputProps: {'aria-label': 'Rows per screen'},
                }}
                labelRowsPerPage={'Rows per screen:'}
                rowsPerPageOptions={tablePageRows}
                onChangeRowsPerPage={(event) => {
                  setRows(event.target.value);
                }}
              />
            ),
          }}
          actions={[
            {
              icon: () => (
                <div>
                  <Button variant="outlined" className={`search-btn ${classes.buttonRoot}`}>
                    <AddIcon /> Add
                  </Button>
                </div>
              ),
              isFreeAction: true,
              onClick: () => {
                handleSelectedNotesOption();
              },
            },
          ]}
        />
      </div>
    </div>
  );
}
